export default __webpack_public_path__ + "static/media/GM_Bowl_Mystic.9aed167c.png";